<template>
  <section class="about-section" v-if="items">
    <div class="about-header">
      <h1 class="about-title">
        {{ $t("About") }}
      </h1>
    </div>

    <div class="about-content-wrapper">
      <div v-html="items.about_us" class="about-content"></div>
    </div>
    
    <div class="about-footer">
      <div class="social-links">
        <a
          :href="items.twitter"
          target="_blank"
          class="social-link"
          v-if="items.twitter"
        >
          <v-icon icon="mdi-twitter"></v-icon>
        </a>
        <a
          :href="items.instagram"
          target="_blank"
          class="social-link"
          v-if="items.instagram"
        >
          <v-icon icon="mdi-instagram"></v-icon>
        </a>
        <a
          :href="items.facebook"
          target="_blank"
          class="social-link"
          v-if="items.facebook"
        >
          <v-icon icon="mdi-facebook"></v-icon>
        </a>
        <a
          :href="items.tiktok || items.socials?.tiktok"
          target="_blank"
          class="social-link tiktok-link"
          v-if="items.tiktok || (items.socials && items.socials.tiktok)"
        >
          <img :src="tiktokIcon" alt="TikTok" class="tiktok-svg-icon" />
        </a>
      </div>
    </div>
  </section>

  <v-row v-else >
      
      <v-col cols="12" v-for="text in texts" :key="text">
        <v-skeleton-loader
          class="mx-auto border-0 "
          type="paragraph"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
</template>

<script>
import crudDataService from "@/Services/crudDataService";
import tiktokIcon from "@/assets/icon/tiktok.svg";
export default {
  data() {
    return {
      items: "",
      tiktokIcon: tiktokIcon,
      texts: [1, 2, 3, 4,5],
    };
  },

  methods: {
    async getabout() {
      let response = await crudDataService.getAll("application-data");
      console.log(response.data.data);
      this.items = response.data.data;
    },
  },
  mounted() {
    this.getabout();
  },
};
</script>

<style lang="scss" scoped>
.about-section {
  width: 100%;
  padding: 32px 0;
}

.about-header {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.about-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin: 0;
}

.about-footer {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.social-links {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #333;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    background: #0074c7;
    color: #ffffff;
    transform: translateY(-2px);
  }
}

.tiktok-link {
  &:hover {
    background: #0074c7;
  }
}

.tiktok-svg-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0);
  transition: filter 0.2s ease;
}

.tiktok-link:hover .tiktok-svg-icon {
  filter: brightness(0) invert(1);
}

.about-content-wrapper {
  margin-top: 24px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;
}

.about-content {
  font-size: clamp(16px, 2.5vw, 18px);
  line-height: 1.8;
  color: #333;
  text-align: center;
  
  :deep(p) {
    margin-bottom: 16px;
  }
  
  :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 16px 0;
  }
  
  :deep(h1), :deep(h2), :deep(h3) {
    color: #333;
    margin-top: 24px;
    margin-bottom: 16px;
  }
}

@media (max-width: 600px) {
  .about-section {
    padding: 24px 0;
  }
  
  .about-content-wrapper {
    padding: 0 12px;
  }
}
</style>
